/*
 *  所有组件导出，用于全局注册
 *  components数组下的组件都是全局注册组件，不需要单独导入
 *  添加一个新公共组件后：
 *    1.在此文件引入 import 组件名 from './路径'
 *    2.在components下添加
 *    3.module.exports对象上添加
 */

import ldHeader from './ldHeader'
import ldIcon from './ldIcon'
import ldDownload from './ldDownload'

const components = [
  ldHeader,
  ldIcon,
]

const plugins = [
  ldDownload
]

const install = (Vue) => {
  if (install.installed) { return }
  install.installed = true
  
  components.map((component) => {
    Vue.component(component.name, component)
    // https://cn.vuejs.org/v2/api/#Vue-component
  })
  
  plugins.map(plugin => {
    Vue.use(plugin, plugin.options || {})
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  version: '0.0.1',
  install: install
}
